import enamad from "../../../Assets/images/enamad.jpeg";

const enamadCode = `
  <img
    src=${enamad}
    width="125"
    height="136"
    onclick='window.open("https://trustseal.enamad.ir/?id=357491&Code=g0QqlYJ0xZ11t7ndnwAF", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
    alt="enamad"
  />
  
<!--  <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=357491&Code='><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=357491&Code=' alt='' style='cursor:pointer' Code=''></a>-->
  `;

export const Enamad = () => {
  return (
    <div
      className="d-flex justify-content-center crsr-pntr m-5"
      dangerouslySetInnerHTML={{ __html: enamadCode }}
    />
  );
};
